import React from 'react';
import { X, MessageSquare } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

/**
 * AI Chatbot Upgrade Dialog Component
 * Displays when free user tries to access AI chatbot feature
 * Similar to Flutter implementation in hamburgerIcon.dart (lines 539-650)
 */
const AIChatbotUpgradeDialog = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleUpgrade = () => {
    onClose();
    navigate('/portal/subscription');
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-[9999] p-4">
      <div className="bg-[#050125] rounded-3xl border border-white/20 max-w-md w-full relative overflow-hidden">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-white hover:text-gray-400 bg-transparent border-none p-1 z-10 transition-colors"
        >
          <X size={20} />
        </button>

        {/* Content */}
        <div className="p-8 flex flex-col items-center">
          {/* Icon */}
          <div className="w-16 h-16 mb-6">
            <MessageSquare className="text-[#C99F4A] w-full h-full" />
          </div>

          {/* Title */}
          <h2 className="text-2xl font-bold text-white text-center mb-4">
            AI Chatbot
          </h2>

          {/* Message */}
          <p className="text-white/70 text-center mb-6 text-sm px-2">
            Upgrade to unlock AI-powered legal assistance!
            <br /><br />
            Available in Basic, Premium & Enterprise plans
          </p>

          {/* Upgrade Button */}
          <button
            onClick={handleUpgrade}
            className="w-32 h-12 bg-[#C99F4A] hover:bg-[#D19B15] text-white rounded-xl font-semibold text-base transition-colors"
          >
            Upgrade
          </button>
        </div>
      </div>
    </div>
  );
};

export default AIChatbotUpgradeDialog;
